/**
 * The symbol used as a key on message objects to store the message type.
 *
 * Note that this is an experimental feature - it is here to stay, but
 * implementation details may change without notice.
 */
export const MESSAGE_TYPE = Symbol.for("protobuf-ts/message-type");
